import {
  RouteResponse,
  isRouteError,
} from '../../dayplanning/dayplanning.types';

/**
 * Count the number of failed routes
 */
export function countFailedRoutes(routes: RouteResponse[] | undefined): number {
  if (!routes) return 0;
  return routes.filter((r) => isRouteError(r)).length;
}

/**
 * Check if any route has a rate limit error
 * Rate limit errors typically contain "rate limit" in the message
 */
export function hasRateLimitError(
  routes: RouteResponse[] | undefined,
): boolean {
  if (!routes) return false;
  return routes.some(
    (r) => isRouteError(r) && r.error?.toLowerCase().includes('rate limit'),
  );
}

/**
 * Get the first rate limit error message if present
 */
export function getRateLimitErrorMessage(
  routes: RouteResponse[] | undefined,
): string | null {
  if (!routes) return null;
  const rateLimitError = routes.find(
    (r) => isRouteError(r) && r.error?.toLowerCase().includes('rate limit'),
  );
  if (rateLimitError && isRouteError(rateLimitError)) {
    return rateLimitError.error;
  }
  return null;
}
